import './cart.scss';

import { CartProvider, ThemeProvider } from '@boost-sd/app';
import { createRoot } from 'react-dom/client';

export const initCart = () => {
  const cartContainerId = 'boost-sd__cart-container';
  const cartContainer = document.createElement('div');
  cartContainer.setAttribute('id', cartContainerId);
  document.body.appendChild(cartContainer);

  const root = createRoot(cartContainer);

  const updateCartIconHeader = (cartItemCount: number) => {
    const cartCountEl = document.querySelector('.cart-link__bubble');

    if (!cartCountEl) return;

    const cartCountClassName = `cart-link__bubble ${
      cartItemCount > 0 ? 'cart-link__bubble--visible' : ''
    }`;

    cartCountEl.className = cartCountClassName;
  };

  root.render(
    <ThemeProvider>
      <CartProvider
        cartIconHeaderSelector='.js-drawer-open-cart'
        onUpdateCart={updateCartIconHeader}
      />
    </ThemeProvider>
  );
};
